<template>
   <b-container>
       <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row><br>
		<b-row >
             <b-col class="text-left">
			<small>Create a new Ticket</small><hr>
        </b-col>
		</b-row> 

        <b-row>
			<b-col>
            <b-form action="createNewTicket" id="viewTicket" method="post" v-on:submit.prevent>
				
					<br><b>Client</b><br>
					<select class="form-control" id="selectClient" name="Client" style="overflow:scroll;" v-model="Client" @change="clientChange()">
						<option disabled selected value="-1"> -- Select a site -- </option>
						
                    <option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}}</option>
					
					</select><br>
					<b>Ticket is </b>		
					<select class="form-control" id="id_siteMeterRelated" name="siteMeterRelated" style="overflow:scroll;" v-model="siteMeterRelated" @change="changeSiteMeterRelated()">
					
                        <option value="MeterRelated">Meter Related</option>
                        <option value="SiteRelated">Site Related</option>
					
					</select><br>
					<div id="meterRelated" v-if="isMeterRelatedBool">
						<b>Meter Account [{{nrMeterAccountsSelected}}]</b><br>
						
						<div v-for="meter in MeterList"  v-bind:key="meter.idMeterAccount">
                            <!--<label><input type="checkbox"  class='serials' name="id_CheckboxMeter" value="meter.idMeterAccount">{{meter.MeterAccountName}}</label>-->
					        <b-form-checkbox class='serials' v-model="meter.isSelected" >{{meter.MeterAccountName}}</b-form-checkbox>
                            <br><hr>
						
						</div>
                        <br>
					
					</div>
					<!-- <b>Title</b><input type="text" name="Header" id="id_Header"  maxlength="249" class="form-control" required></input><br> -->
					<b>Description</b><textarea  rows="3" name="Description" id="id_Description" class="form-control" v-model="Description"></textarea><br>
					<b>Select stage of work</b>		
					<select class="form-control" id="id_Department" name="Department" style="overflow:scroll;" v-model="Department" @change="stageWorkChanged">
					    <option disabled selected value="-1"> -- Select stage of work -- </option>
                         <option v-for="dept in departments"  v-bind:key="dept.idDepartment" :value="dept.idDepartment" >{{dept.Name}}</option>
					
					</select><br>
                    <div v-if="showCategory">
                    <b>Category</b>		
					<select class="form-control" id="id_Category" name="Category" style="overflow:scroll;" v-model="Category" @change="categoryChange()">
                          <option disabled selected value="-1"> -- Select a category -- </option>
                         <option v-for="Category in filteredCategory"  v-bind:key="Category.idTicketCategory" :value="Category.idTicketCategory" >{{Category.CategoryName}}</option>
					</select><br>
                    </div>
					<div id="subCategoryDiv" v-if="showSubCategory"> 
						<b>Sub Category</b>
						<select class="form-control" id="id_SubCategory" name="SubCategory" style="overflow:scroll;" v-model="SubCategory" @change="subCategoryChange(SubCategory)">
							<option disabled selected value="-1"> -- Select a subcategory -- </option>
                            <option v-for="SubCategory in SubCategoryList"  v-bind:key="SubCategory.idTicketSubCategory" :value="SubCategory.idTicketSubCategory" >{{SubCategory.Name}}</option>
						</select><br>
						<b>Sub Category Description</b><textarea readonly rows="3" name="SubCatDescription" id="id_SubCatDescription" class="form-control" v-model="SubCatDescription"></textarea><br>
					
					</div>
					<b>Ticket valid from</b>
                    <datetime v-model="TicketIssued" type="datetime" zone="local" value-zone="local"></datetime><br>
                    
					<b>Reason for fault</b>		
					<select class="form-control" id="id_Reason" name="Reason" style="overflow:scroll;" v-model="Reason">
					    <option disabled selected value="-1"> -- Select a reason -- </option>
					    <option v-for="reason in ReasonList"  v-bind:key="reason.idTicketReason" :value="reason.idTicketReason" >{{reason.Name}}</option>

					</select><br>
					
                    
					
					<div class="checkbox">
					  <!--<label><input type="checkbox"  id="reminderCheckbox" name="reminder" value="" checked v-model="reminder"><b>Automatically send reminder ticket</b></label>-->
					    <b-form-checkbox v-model="reminder">Automatically send reminder ticket</b-form-checkbox>
					</div><br>
					<div class="checkbox">
					  <!--<label><input type="checkbox"  id="jobCheckbox" name="isJob" value="" v-model="isJob"><b>Assign as a job to somebody else to complete</b></label>-->
                        <b-form-checkbox v-model="isJob">Assign as a job to somebody else to complete</b-form-checkbox>
					</div>
					<div id="isJobDiv" v-if="isJob">
					Assign job to
					<select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="Employee">
                          <option disabled selected value="-1"> -- Select an employee to assign job to -- </option>
                        <option v-for="emp in EmployeeList"  v-bind:key="emp.idEmployee" :value="emp.idEmployee" >{{emp.employee}}</option>
					
					</select>
					</div><br>
					
					<div class="checkbox">
					  <!--<label><input type="checkbox"  id="resolveCheckbox" name="resolve" value="" v-model="resolve"><b>Resolve this ticket</b> [ Only tick when no further action is required]</label>-->
					   <b-form-checkbox v-model="resolve">Resolve this ticket [ Only tick when no further action is required]</b-form-checkbox>
					</div>
					<div id="resolveDiv" v-if="resolve">
					Resolve Date
                    <datetime v-model="resolveDate" type="datetime" zone="local" value-zone="local"></datetime><br>
					<br>
					Resolve Comment
					<input type="text" name="resolveComment" id="resolveComment" class="form-control" value='None' v-model="resolveComment"></input><br>
					</div><br>
					<div hidden>
					<input hidden type="text" name="calcCost" id="id_CalcCost" class="form-control" value='false'></input><br>
					</div>
					<b>Priority</b>		
					<select class="form-control" id="id_Priority" name="Priority" style="overflow:scroll;" v-model="Priority">
                        <option v-for="Priority in PriorityList"  v-bind:key="Priority.idTicketPriority" :value="Priority.idTicketPriority" >{{Priority.Name}}</option>
					</select><br>
					<div id="dueDateDiv" v-if="isJob">
                        <b>Ticket Due Date ( Change where Applicable )</b>
                        
                         <datetime v-model="ticketduedate" type="datetime" zone="local" value-zone="local"></datetime><br><br>

                    </div>
					
					
					
					<b>Supplies</b><input type="text" name="Supplies" id="id_Supplies"  maxlength="500" class="form-control" value='None' v-model="Supplies"></input><br>
					<!--<b>Add Ticket Tags (Optional)</b><hr>
					<div id="addTag"></div>-->
					<component-tagEmployee @updateEmployeeTagged="updateEmployeeTagged" :header="userTagHeader" :employeeTagged=" employeeTagged"></component-tagEmployee>
					<input type="submit" value="Create Ticket" class="btn btn-primary" id="submitbtn" style="width:100%;" @click="submit">
				
			</b-form>
			</b-col>
           
		</b-row>
        <b-row>
             <b-col>
                <br>
            </b-col>
        </b-row>
        <b-row>
             <b-col>
                <br>
            </b-col>
        </b-row>

		
      </b-container>
</template>
<script type="text/javascript">
//const ActionButton = require('./ActionButton.vue');
import axios from 'axios';
import moment from 'moment';
import tagEmp from '../components/tagEmployee.vue'

//module.exports = {
  export default {
    
    
  name: 'createTicket',
  components: {
    'component-tagEmployee' : tagEmp
   },  
  data: () => ({
    Client : -1,
    sites : [],
    siteMeterRelated : "SiteRelated",
    ListEmployeeTagged : [],
    userTagHeader : "Subscribe employees to this ticket : ( This will allow them to receive updates )",
    employeeTagged : [],
    isMeterRelatedBool : false,
    MeterList : [],
    Department : -1,
    departments : [],
    TicketIssued : null,
    Description : null,
    Reason :3,
    ReasonList : [],
    reminder : null,
    isJob : false,
    Employee : -1,
    EmployeeList : [],
    resolve : false,
    resolveDate : null,
    resolveComment : "",
    Priority : 4,
    ticketduedate : null,
    PriorityList : [],
    Category : -1,
    CategoryList : [],
    SubCategory : null,
    showSubCategory : false,
    showCategory : false,
    SubCategoryList : [],
   
    SubCatDescription : "",
    calcCost : 0,
    Supplies : ""
    
    
    
  }),
  computed: {
    filteredCategory : function ()
    {
        var self = this;
        let cats = [];
        cats =  self.CategoryList.filter(function (cat) {
            // do not filter by sub category
            
                // filter by subcategory
            if ( cat.idDepartment== self.Department )
                return true;
            else
                return false;

        })
        return cats;
    },

    nrMeterAccountsSelected: function () {
      if ( this.MeterList.length > 0 )
      {
          var countSelected = 0;
          this.MeterList.forEach(meter => {
              if (meter.isSelected) countSelected++;
              
          });
          return countSelected;
      }
      else
      {
          return 0;
      }
      
     
    },
    ticketduedateFormatted : function ()
    {
        return moment(this.ticketduedate).format("YYYY-MM-DD HH:mm");
    },
    resolveDateFormatted : function ()
    {
        return moment(this.resolveDate).format("YYYY-MM-DD HH:mm");
    },
    TicketIssuedFormatted : function ()
    {
        return moment(this.TicketIssued).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
      submit : function() {
        console.log("Submit");
        let mainObject = this;
        var submitobject = new Object;
        submitobject.Client = this.Client;
        submitobject.siteMeterRelated = this.siteMeterRelated;
        submitobject.Description = this.Description;
        submitobject.Department = this.Department;
        submitobject.TicketIssued = this.TicketIssuedFormatted;
        submitobject.idLogger =  localStorage.getItem('idemployee');
        submitobject.Logger =  localStorage.getItem('employee');
        submitobject.Reason = this.Reason;
        submitobject.reminder = this.reminder;
        submitobject.isJob = this.isJob;
        submitobject.Employee = this.Employee;
        submitobject.resolve = this.resolve;
        submitobject.resolveDate = this.resolveDateFormatted;
        submitobject.resolveComment = this.resolveComment;
        submitobject.calcCost = this.calcCost;
        submitobject.Priority = this.Priority;
        submitobject.ticketduedate = this.ticketduedateFormatted;
        submitobject.Category = this.Category;
        submitobject.SubCategory = this.SubCategory;
        submitobject.SubCatDescription = this.SubCatDescription;
        submitobject.Supplies = this.Supplies;
        submitobject.isMeterRelatedBool = this.isMeterRelatedBool;
        submitobject.MeterList = this.MeterList;
        submitobject.calcCost = this.calcCost;
        submitobject.ListEmployeeTagged = this.ListEmployeeTagged;
        console.log("submitobject");
        console.log(submitobject);  
        // Do validation
        let validObject = true;
        switch ( true )
        {
            case  ( (submitobject.Description == null)||( submitobject.Description == ""))  : 
                validObject = false;
                mainObject.showAlert("Please add a description.",2000,false);
                break;
            case  ( (submitobject.Client == null)||( submitobject.Client < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a site.",2000,false);
                break;
            case  ( (submitobject.Department == null)||( submitobject.Department < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a department.",2000,false);
                break;
            case  ( (submitobject.Category == null)||( submitobject.Category < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a category.",2000,false);
                break;
            case  ( (submitobject.SubCategory == null)||( submitobject.SubCategory < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select a subcategory.",2000,false);
                break;
            case  ( (submitobject.isJob == true)&&( submitobject.Employee < 1) )  : 
                validObject = false;
                mainObject.showAlert("Please select an employee to assign job to.",2000,false);
                break;
            case  ( (submitobject.isMeterRelatedBool == true)&&( this.nrMeterAccountsSelected < 1) )  : 
                validObject = false;
                mainObject.showAlert("Please select a meter account or change to site related.",2000,false);
                break;


                

                

            default : validObject = true;
        }
        if ( validObject )
        {
            var authheader = "Bearer "+localStorage.getItem('jwt');
            axios.post(localStorage.getItem('ticketCopURL') +'/createNewTicket', {
                
                data : submitobject
                //}
            },  {headers: { "Authorization" : authheader }}
            )
            .then(function (response) {
                console.log(response.data);
                if ( response.data.status == "Success")
                {
                    console.log("ticket was succesfully created")
                    let text = "<strong>Ticket # <h3> " + response.data.idTicket + "</strong>"
                    //mainObject.showAlert(text,2000,false);
                    mainObject.$swal({
                                            title: text,
                                            text: 'Was successfully created.',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'Click to create another Ticket',
                                            cancelButtonText:  'Return to Home'
                                            }).then((result) => {
                                            if (result.value) 
                                            {
                                                console.log("Relaod the page");
                                                //mainObject.clearAll();
                                                mainObject.$router.go()

                                            }
                                            else
                                            {
                                                 mainObject.$router.go(-1);

                                            }
                                            });
                }
                else
                {
                    console.log("error inserting ticket");
                    mainObject.showAlert("Error could not insert ticket.",2000,false);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
         
                console.log("Done inserting ticket");
            })
        }
        else
        {
            console.log("Failed Validation");
        }
      },
    
      updateEmployeeTagged : function(e)
      {
          this.ListEmployeeTagged = e;
          console.log("Main Component list")
          console.log(this.ListEmployeeTagged);
      },
      changeSiteMeterRelated : function()
      {
          let mainObject = this;
          if ( mainObject.siteMeterRelated == "MeterRelated" )
          {
              mainObject.isMeterRelatedBool = true;
          }
          else
                 mainObject.isMeterRelatedBool = false;

      },
      
      stageWorkChanged : function ()
      {
            this.Category = -1;
            this.SubCategory = -1;
            this.showSubCategory = false;
            this.showCategory =true;

      },

      categoryChange : function()
      {
          let mainObject = this;
          axios.get(localStorage.getItem('ticketCopURL') +'/getSubCategories', {
          params: {
              idTicketCategory : mainObject.Category
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          mainObject.showSubCategory = true;
          mainObject.SubCategory = -1;
          console.log(response.data);
          mainObject.SubCategoryList = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
        });// end of axios call
      },

      clientChange : function()
      {
          let mainObject = this;
          console.log("Client changed");
          axios.get(localStorage.getItem('ticketCopURL') +'/getMeters', {
          params: {
              SiteCode : mainObject.Client
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
            console.log("getMeters");
          console.log(response.data);
          response.data.forEach(meter => {
              meter.isSelected = false;
              
          });
          mainObject.MeterList = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          // special case when the site is head office site id 97

          console.log("Todo when head office hide meterrelated options");

        });// end of axios call
      },

      subCategoryChange : function(subCat)
      {
         console.log(subCat);
         this.calcCost = 0;
         for( var i = 0 ; i < this.SubCategoryList.length ; i++ )
         {
             if ( this.SubCategoryList[i].idTicketSubCategory == subCat )
             {
                 this.calcCost = this.SubCategoryList[i].CalcCost;
                 this.SubCatDescription = this.SubCategoryList[i].CatDesc;
                console.log("Calcost was set to :"+this.calcCost);
                 break
             }
         }
          
      },

      priorityChange : function()
      {
          console.log("toDo change add days based on priority updatefrequency and set the due date");
      },

      meterRelatedChange : function()
      {
          console.log("show and hide options when siteralted also cater for site 97");
      },

      showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
      }
      /*,

      clearAll : function ()
      {
            let self = this;
            self.Client = -1;
            self.sites = [];
            self.siteMeterRelated = "SiteRelated";
            self.isMeterRelatedBool = false;
            self.MeterList = [];
            self.Department = -1;
            self.departments = [];
            self.TicketIssued = null;
            self.Description = null;
            self.Reason =3;
            self.ReasonList = [];
            self.reminder = null;
            self.isJob = false;
            self.Employee = -1;
            self.EmployeeList = [];
            self.resolve = false;
            self.resolveDate = null;
            self.resolveComment = "";
            self.Priority = 4;
            self.ticketduedate = null;
            self.PriorityList = [];
            self.Category = -1;
            self.CategoryList = [];
            self.SubCategory = null;
            self.showSubCategory = false;
            self.SubCategoryList = [];
            self.SubCatDescription = "";
            self.calcCost = 0;
            self.Supplies = "";
            console.log("Cleared all parameters");
            self.resolveDate = moment().toISOString(true);
            self.TicketIssued =  moment().toISOString(true);
            self.ticketduedate = moment().toISOString(true);
      }*/

      
      
  },
  
  created: function () {
    console.log("created called");
    this.employee =  localStorage.getItem('employee');
    var objectMain = this;
    console.log("Time now");
    console.log(moment());
    objectMain.resolveDate = moment().toISOString(true);
    objectMain.TicketIssued =  moment().toISOString(true);
    objectMain.ticketduedate = moment().toISOString(true);

    console.log("objectMain.resolveDate");
    console.log(objectMain.resolveDate );
    console.log("objectMain.TicketIssued");
    console.log(objectMain.TicketIssued );
    console.log("objectMain.ticketduedate");
    console.log(objectMain.ticketduedate );

    axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response.data);
          objectMain.EmployeeList = response.data.users;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call

    axios.get(localStorage.getItem('ticketCopURL') +'/getSites', {
          params: {
          
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          objectMain.sites = response.data;
          console.log(response);
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call
 // use to be getCategories
    axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentCategory', {
          params: {
          
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          objectMain.CategoryList = response.data;
          console.log(response);
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call
    


    axios.get(localStorage.getItem('ticketCopURL') +'/getPriorityTicket', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          objectMain.PriorityList = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          
    });// end of axios call

    axios.get(localStorage.getItem('ticketCopURL') +'/getReasonTicket', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
            objectMain.ReasonList = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          console.log("Made request to get ticket info for idTicket ");
          console.log(objectMain);
    });// end of axios call

    axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentTicket', {
          params: {
            idTicket : objectMain.idTicket
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
         objectMain.departments = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call

  }
  
};
</script>




















































	

		
	
		
		
	
		
		
		
		
		
		
		
		
		
		
		
		

			
		
		
		
		
		
		
		
		
		
		
	

	

	

	


